<div class="gateway">
  <div class="gateway__header">
    <h1 class="gateway__title">Gateway Data</h1>
    <button type="button" class="gateway__close" aria-label="Close" (click)="closeModal()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>

  @if (dataModel === 'model1') {
    @if (isLoading) {
      <div class="gateway__loading">
        <div class="gateway__spinner" role="status" aria-live="polite"></div>
        <p class="gateway__loading-text">Fetching entity data...</p>
      </div>
    }

    @if (errorMessage && !isLoading) {
      <div class="gateway__error">
        <div class="gateway__error-alert">{{ errorMessage }}</div>
      </div>
    }

    @if (!isLoading && !errorMessage && allData.length > 0) {
      <div class="gateway__info">
        <span class="gateway__info-text">
          Showing {{ startIndex }} - {{ endIndex }} of {{ allData.length }} entries
        </span>
      </div>
      <div class="gateway__body">
        <code class="gateway__code">{{ displayData }}</code>
      </div>
      <div class="gateway__footer">
        <div class="gateway__pagination">
          <button type="button" class="gateway__nav-btn" (click)="firstPage()" [disabled]="currentPage === 1" title="First page">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4L2 8L6 12M10 12L14 8L10 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <button type="button" class="gateway__nav-btn" (click)="previousPage()" [disabled]="currentPage === 1" title="Previous page">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <div class="gateway__page-numbers">
            @for (page of getPageNumbers(); track page) {
              <button type="button" class="gateway__page-btn" [class.gateway__page-btn--active]="page === currentPage" (click)="goToPage(page)">
                {{ page }}
              </button>
            }
          </div>
          <button type="button" class="gateway__nav-btn" (click)="nextPage()" [disabled]="currentPage === totalPages" title="Next page">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <button type="button" class="gateway__nav-btn" (click)="lastPage()" [disabled]="currentPage === totalPages" title="Last page">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4L2 8L6 12M10 12L14 8L10 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
        </div>
        <div class="gateway__download-wrap">
          <button type="button" class="gateway__download-btn" (click)="downloadAllData()">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Download All Data
          </button>
        </div>
      </div>
    }
  }

  @if (dataModel === 'model2') {
    <div class="gateway__date-section">
      <div class="gateway__date-header">
        <h5 class="gateway__date-title">Temporal Data Query</h5>
        <p class="gateway__date-desc">Select a date range to fetch temporal data</p>
      </div>
      <div class="gateway__date-inputs">
        <div class="gateway__date-group">
          <label for="startDate" class="gateway__label">Start Date</label>
          <input type="date" id="startDate" class="gateway__input" [(ngModel)]="startDate" [max]="maxDateStr" [min]="minDateStr" />
        </div>
        <div class="gateway__date-group">
          <label for="endDate" class="gateway__label">End Date</label>
          <input type="date" id="endDate" class="gateway__input" [(ngModel)]="endDate" [max]="maxDateStr" [min]="minDateStr" />
        </div>
        <div class="gateway__date-actions">
          <button type="button" class="gateway__search-btn" (click)="searchTemporalData()" [disabled]="!startDate || !endDate || isLoading">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
            Search
          </button>
          <button type="button" class="gateway__reset-btn" (click)="resetDates()" [disabled]="(!startDate && !endDate) || isLoading" title="Reset dates">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
            Reset
          </button>
        </div>
      </div>
    </div>

    @if (isLoading) {
      <div class="gateway__loading">
        <div class="gateway__spinner" role="status"></div>
        <p class="gateway__loading-text">Fetching temporal data...</p>
      </div>
    }

    @if (errorMessage && !isLoading) {
      <div class="gateway__error">
        <div class="gateway__error-alert">{{ errorMessage }}</div>
      </div>
    }

    @if (!isLoading && !errorMessage && allData.length > 0) {
      <div class="gateway__info">
        <span class="gateway__info-text">Showing {{ startIndex }} - {{ endIndex }} of {{ allData.length }} entries</span>
      </div>
      <div class="gateway__body">
        <code class="gateway__code">{{ displayData }}</code>
      </div>
      <div class="gateway__footer">
        <div class="gateway__pagination">
          <button type="button" class="gateway__nav-btn" (click)="firstPage()" [disabled]="currentPage === 1" title="First page">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4L2 8L6 12M10 12L14 8L10 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <button type="button" class="gateway__nav-btn" (click)="previousPage()" [disabled]="currentPage === 1" title="Previous page">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <div class="gateway__page-numbers">
            @for (page of getPageNumbers(); track page) {
              <button type="button" class="gateway__page-btn" [class.gateway__page-btn--active]="page === currentPage" (click)="goToPage(page)">{{ page }}</button>
            }
          </div>
          <button type="button" class="gateway__nav-btn" (click)="nextPage()" [disabled]="currentPage === totalPages" title="Next page">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <button type="button" class="gateway__nav-btn" (click)="lastPage()" [disabled]="currentPage === totalPages" title="Last page">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4L2 8L6 12M10 12L14 8L10 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
        </div>
        <div class="gateway__download-wrap">
          <button type="button" class="gateway__download-btn" (click)="downloadAllData()">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>
            Download All Data
          </button>
        </div>
      </div>
    }
  }
</div>
